export const getAttachmentPreviewUrl = (attachmentId: string): string =>
	`/api3.2/noauth/bucket/${attachmentId}`;
